// src/utils/auditUtils.ts

import type { ClaimRequestType } from "../../features/claim/types/claimType";

export const buildClaimStatusAuditHistory = (prevClaim: ClaimRequestType, values: any, action: "approve" | "reject") => {
    const changedValues: { fieldName: string; oldValue: string; newValue: string }[] = [];

    if (action === "approve") {
        changedValues.push({
            fieldName: "status",
            oldValue: prevClaim.status ?? "",
            newValue: "Approved",
        });
        // Approved Amount change
        if (prevClaim.approvedAmount !== values.approvedAmount) {
            changedValues.push({
                fieldName: "approvedAmount",
                oldValue: String(prevClaim.approvedAmount ?? 0),
                newValue: String(values.approvedAmount ?? 0),
            });
        }
        // Reason change
        if (prevClaim.reason !== values.reason) {
            changedValues.push({
                fieldName: "reason",
                oldValue: prevClaim.reason ?? "",
                newValue: values.reason ?? "",
            });
        }
    } else if (action === "reject") {
        changedValues.push({
            fieldName: "status",
            oldValue: prevClaim.status ?? "",
            newValue: "Rejected", // or your rejected status value
        });

        // Reason change
        if (prevClaim.reason !== values.reason) {
            changedValues.push({
                fieldName: "reason",
                oldValue: prevClaim.reason ?? "",
                newValue: values.reason ?? "",
            });
        }
    }

    return changedValues;
};

export const buildMedicalProviderAuditHistory = (record: any, action: "activate" | "inactivate") => {
    const changedValues: { fieldName: string; oldValue: string; newValue: string }[] = [];

    if (action === "activate") {
        changedValues.push({
            fieldName: "isActive",
            oldValue: record.isActive ? "Yes" : "No",
            newValue: "Yes",
        });
    } else if (action === "inactivate") {
        changedValues.push({
            fieldName: "isActive",
            oldValue: record.isActive ? "Yes" : "No",
            newValue: "No",
        });
    }

    return changedValues;
};

